import { cropSelector } from "store/features/crop/selectors/cropSelector";
import { CropState } from "store/features/crop/types";
import { useAppSelector } from "store/store";

export const useSize = () => {
    const {
        crop: { height, width },
    } = useAppSelector(cropSelector, equalityFn);

    return {
        height,
        width,
    };
};

const equalityFn = (left: CropState, right: CropState) => {
    if (left.crop.height !== right.crop.height || left.crop.width !== right.crop.width) return false;

    return true;
};
